import { MarketsState } from './types';
import { setAsyncData } from '../core';
import { MarketsActions } from './actions';

const initialState: MarketsState = {
  markets: { isFetching: false },
  allMarkets: { isFetching: false },
};

export function marketsReducer(state: MarketsState = initialState, action: MarketsActions): MarketsState {
  switch (action.type) {
    case 'MARKETS_SET_IS_FETCHING':
      return {
        ...state,
        markets: setAsyncData(state.markets, (v) => (v.isFetching = action.data)),
        allMarkets: setAsyncData(state.allMarkets, (v) => (v.isFetching = action.data)),
      };

    case 'MARKETS_SET_MARKETS':
      return {
        ...state,
        markets: setAsyncData(state.markets, (v) => (v.data = action.data.filter((m) => m.active))),
        allMarkets: setAsyncData(state.allMarkets, (v) => (v.data = action.data)),
      };

    default:
      return state;
  }
}
